import { render, staticRenderFns } from "./Payflex.vue?vue&type=template&id=e1cf999a&scoped=true"
import script from "./Payflex.vue?vue&type=script&lang=js"
export * from "./Payflex.vue?vue&type=script&lang=js"
import style0 from "./Payflex.vue?vue&type=style&index=0&id=e1cf999a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cf999a",
  null
  
)

export default component.exports